import React from "react";
import { IconButton, Text, Avatar, HStack, Flex } from "@chakra-ui/react";
import { IoLogOutOutline } from "react-icons/io5";
import { apolloClient } from "configs";
import { useAuth, getImageUrl, useOnline, dbQueries } from "duck";
import { useLogoutMutation } from "requests";

const UserProfile: React.FC = () => {
  const online = useOnline();

  const [{ user }, setAuth] = useAuth();
  const [logout] = useLogoutMutation();

  const fullName = `${user.firstName} ${user.lastName}`;

  return (
    <Flex mr="-2" align="center" py="3.5">
      <HStack>
        <Avatar
          size="sm"
          name={fullName}
          src={user.image?._id ? getImageUrl(user.image?._id) : undefined}
        />
        <Text fontSize="sm" color="gray.900">
          {fullName}
        </Text>
      </HStack>
      {online && (
        <IconButton
          variant="unstyled"
          display="flex"
          aria-label="Log out"
          color="gray.900"
          onClick={() => {
            dbQueries.deleteUser(user._id);
            logout();
            localStorage.removeItem("sessionId");
            setAuth(prev => ({ ...prev, user: null } as any));
            apolloClient.cache.evict({ id: "ROOT_QUERY" });
          }}
          icon={<IoLogOutOutline fontSize="1.5rem" />}
        />
      )}
    </Flex>
  );
};

export default UserProfile;
